<template>
  <el-dialog
    :title="'配件销售出库信息'"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <el-form
      status-icon
      :model="form"
      ref="form"
      label-position="right"
      label-width="100px"
      style="width: 100%"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="配件名称" prop="PartName">
            <el-input
              v-model="form.PartName"
              placeholder="配件名称"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="配件数量" prop="PartQuantity">
            <el-input
              v-model="form.PartQuantity"
              placeholder="配件数量"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="配件单位" prop="Unit">
            <el-input
              v-model="form.Unit"
              placeholder="配件单位"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="配件售价" prop="Price">
            <el-input v-model="form.Price" placeholder="配件售价"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-divider content-position="left">配件详细信息</el-divider>
    <div style="width: 100%; height: 400px; overflow: auto">
      <el-table
        style="width: 100%; margin-top: 10px"
        :data="data.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
        @selection-change="handleSelectionChange"
        :row-key="
          (row) => {
            return row.EntryId;
          }
        "
        ref="multipleTable"
      >
        <el-table-column type="selection" :reserve-selection="true" width="55">
        </el-table-column>
        <el-table-column
          label="配件名称"
          prop="PartsName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="配件来源"
          prop="Source"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="仓库名称"
          prop="WarehouseName"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="数量"
          prop="Quantity"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="单位"
          prop="Unit"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="总重量" prop="Weight" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="data.length"
    >
    </el-pagination>
    <span slot="footer">
      <el-button type="primary" @click="save" :loading="loading"
        >确认销售</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ["item"],
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      pageIndex: 1,
      pageSize: 5,
      pageTotal: 0,
      data: [],
      currentPage: 1, //初始页
      form: {},
      savelist: [],
      rules: {
        Price: [
          {
            required: true,
            message: "不可为空",
            ...this.$g.validNumber,
          },
        ],
      },
    };
  },
  watch: {
    item: {
      handler: function (v) {
        if (v.EntryId) {
          this.isEdit = true;
        } else {
          this.init({});
          this.isEdit = false;
        }
        this.visible = true;
        this.handledata();
      },
    },
  },
  created() {
    this.handledata();
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },

    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(size) {
      this.pageSize = size;
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    handledata() {
      this.$get("AccessoryEntryRecords/GetOutAccessoryList", {
        WarehouseId: this.item.WarehouseId,
        PartsId: this.item.PartsId,
      })
        .then((res) => {
          this.data = res.Result;
          this.$refs.multipleTable.clearSelection();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      var selrow = this.selectedRows;
      var op = {};
      var QuantNum = 0;
      var EntryIdstr = "",
        Sourcesstr = "";
      this.savelist = [];
      if (selrow != null && selrow != "") {
        selrow.forEach((item) => {
          QuantNum += parseInt(item.Quantity);
          EntryIdstr =
            EntryIdstr == "" ? item.EntryId : EntryIdstr + "," + item.EntryId;
          Sourcesstr =
            Sourcesstr == "" ? item.Sources : Sourcesstr + "," + item.Sources;
        });

        op.PartName = selrow[0].PartsName;
        op.Quantity = QuantNum;
        op.Unit = selrow[0].Unit;
        op.InventoryId = EntryIdstr;
        //op.Sources = Sourcesstr;
        op.Price = 0;
        this.savelist.push(op);
        this.$set(this.form, "PartName", op.PartName);
        this.$set(this.form, "PartQuantity", QuantNum);
        this.$set(this.form, "Unit", op.Unit);
      }
    },

    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        this.savelist[0].Price = this.form.Price;
        this.loading = true;
        this.$post("SalesPart/Add", this.savelist[0]).then((r) => {
          this.$message.success("添加成功");
          this.visible = false;
          this.$emit("success");
        });
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>
